import { useResponsive } from '../../dashboards/components/hooks/useResponsive';
import { MOBILE_NAV_ENABLED } from './mobileNavFlag';

/**
 * Whether the mobile navigation is on screen: the flag is on and the viewport is below the desktop
 * breakpoint, the same width at which the sidebar already collapses into a drawer.
 */
export const useMobileNav = (): boolean => {
    const { isDesktop } = useResponsive();
    return MOBILE_NAV_ENABLED && !isDesktop;
};
